let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2jNTG")).then(() => parcelRequire('2NCJ7'));